import api from "@/services/api/api-cm"
import CMDateModel from "../classes/CMDate"
import CourseModel, { CourseModelDetailed } from "@/app/admin/models/courseModel"
import CMExamConfig, {CMExamConfigApiData, CMExamHourFormatter, CM_EXAM_CONFIG} from "../classes/CMExamConfig"
import {CMLocationApiData} from "../classes/CMLocationConfigModel"
import { dateFormating, convertToDefaultBackendFormat } from "@/util"
import PaginationModel from "@/models/paginationModel"
import { formattedDate } from "@/util/filters"
import { CourseDate } from "./models/cm-date.model"



export default class CMService {
  constructor(api) {
    this.api = api
  }

  async list(query) {
    try {
      // let res = await api.list(query)
      // if(!res) throw new Error('Something wrong and account not loaded. Please, reload page or try later.')

      // return data
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async courseList(query) {
    try {
      let res = await api.courseListDetailed(query)
      let courseListArr = res;
      if (!Array.isArray(res) && Array.isArray(res.results)) courseListArr = res.results
      let list = courseListArr.map(item => new CourseModelDetailed(item))
      return list
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async courseListOnlyDates(query) {
    try {
      const list  = await api.courseListOnlyDates(query)
      return list.map(item => new CourseDate(item))
    } catch (err) {
      return Promise.reject(err)
    }
  }

  async courseListWithPagination(query) {
    try {
      let res = await api.courseListDetailed(query)
      const list = res.results.map(item => new CourseModelDetailed(item))
      const pagination = new PaginationModel(res);
      return {
        list,
        pagination
      };
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async createCourse(data) {
    try {
      let res = await api.createCourse({
        city: data.city,
        date: data.date ? dateFormating(data.date).join('-'): null,
        notes: data.notes,
        max_students: data.maxStudents,
        is_visible_on_landing: data.isVisibleOnLanding,
        free_places: +data.freePlaces,
        name: data.name,
        is_provided: data.is_provided
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateCourse(courseID, data) {
    try {
      let res = await api.updateCourse(courseID, {
        notes: data.notes,
        max_students: data.maxStudents,
        is_visible_on_landing: data.is_visible_on_landing,
        free_places: data.free_places,
        name: data.name,
        leaders: data.leaders,
        is_provided: data.is_provided
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async removeCourse(courseID, data) {
    try {
      let res = await api.removeCourse(courseID)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async saveNote(courseId, notes) {
    return await this.updateCourse(courseId, { notes })
  }

  async createExam(courseID, data) {
    try {
      let apiData = new CMExamConfigApiData(data).convert()
      let res = await api.createExam(courseID, apiData)
      return new CMExamConfig(
        new CMExamHourFormatter(res).execute()
      )
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getConfig(courseID) {
    try {
      let res = await api.getConfig(courseID)
      let list = res.map(item => new CMExamConfig(
        new CMExamHourFormatter(item).execute()
      ))
      return list
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async createConfig(courseID, data) {
    try {
      let apiData = new CMExamConfigApiData({
        ...data,
        date: dateFormating(data.date).join('-')
      }).convert()
      let res = await api.createConfig(courseID, apiData)
      return new CMExamConfig(
        new CMExamHourFormatter(res).execute()
      )
    } catch (error) {
      return Promise.reject(error)
    }
  }
  
  async updateConfig(payload) {
    try {
      let apiData = new CMExamConfigApiData({
        ...payload.data,
        date: dateFormating(payload.data.date).join('-')
      }).convert()
      let res = await api.updateConfig({ ...payload, data: apiData })
      return new CMExamConfig(
        new CMExamHourFormatter(res).execute()
      )
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async removeConfig(payload) {
    try {
      let res = await api.removeConfig(payload)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getCourseConfiguration(courseID) {
    try {
      let res = await api.getCourseConfiguration(courseID)
      
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async createCourseConfiguration(courseID, data) {

    try {
      let res = await api.createCourseConfiguration(courseID, {
        ...new CMLocationApiData(data).convert()
      })
      
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateCourseConfiguration(courseID, configurationID, data) {
    try {
      let res = await api.updateCourseConfiguration(courseID, configurationID, {
        ...new CMLocationApiData(data).convert()
      })
      
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

}
